import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IInventoryTemplatePresetRepository } from '../interfaces/IInventoryTemplatePresetRepository';
import {
  InventoryExportPresetApi,
  GetInventoryExportPresetListSuccessResponseAllOfResult,
  InventoryExportPresetDetailSuccessResponseAllOfResult,
  InventoryExportPresetUpsertRequest,
} from '../axios/generated/inventoryManage';
import { IError } from '../interfaces/IError';
import { axiosErrorHandler } from '../axios/axiosError';
import { customAxiosInstance } from '../axios/axiosInstance';

/**
 * 出力条件プリセットAPIを呼び出すRepository
 */
export class InventoryTemplatePresetRepository implements IInventoryTemplatePresetRepository {
  /**
   * 出力条件プリセット一覧を取得する
   */
  public async getList(): Promise<INetworkResult<GetInventoryExportPresetListSuccessResponseAllOfResult, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const inventoryExportPresetApi = new InventoryExportPresetApi(undefined, undefined, axiosInstance);
    try {
      const apiResponse = await inventoryExportPresetApi.getInventoryExportPresetList();
      switch (apiResponse.status) {
        case 200:
          return { status: { type: 'success', data: apiResponse.data.result } };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (error) {
      return { status: { type: 'error', error: axiosErrorHandler(error) } };
    }
  }

  /**
   * 出力条件プリセットを新規登録する
   * @param request - 登録内容
   */
  public async create(
    request: InventoryExportPresetUpsertRequest
  ): Promise<INetworkResult<InventoryExportPresetDetailSuccessResponseAllOfResult, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const inventoryExportPresetApi = new InventoryExportPresetApi(undefined, undefined, axiosInstance);
    try {
      const apiResponse = await inventoryExportPresetApi.createInventoryExportPreset(request);
      switch (apiResponse.status) {
        case 200:
          return { status: { type: 'success', data: apiResponse.data.result } };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (error) {
      return { status: { type: 'error', error: axiosErrorHandler(error) } };
    }
  }

  /**
   * 出力条件プリセットを更新する
   * @param presetId - プリセットID
   * @param request - 更新内容
   */
  public async update(
    presetId: string,
    request: InventoryExportPresetUpsertRequest
  ): Promise<INetworkResult<InventoryExportPresetDetailSuccessResponseAllOfResult, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const inventoryExportPresetApi = new InventoryExportPresetApi(undefined, undefined, axiosInstance);
    try {
      const apiResponse = await inventoryExportPresetApi.updateInventoryExportPreset(presetId, request);
      switch (apiResponse.status) {
        case 200:
          return { status: { type: 'success', data: apiResponse.data.result } };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (error) {
      return { status: { type: 'error', error: axiosErrorHandler(error) } };
    }
  }

  /**
   * 出力条件プリセットを削除する
   * @param presetId - プリセットID
   */
  public async delete(presetId: string): Promise<INetworkResult<void, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const inventoryExportPresetApi = new InventoryExportPresetApi(undefined, undefined, axiosInstance);
    try {
      const apiResponse = await inventoryExportPresetApi.deleteInventoryExportPreset(presetId);
      switch (apiResponse.status) {
        case 200:
          return { status: { type: 'success', data: undefined } };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (error) {
      return { status: { type: 'error', error: axiosErrorHandler(error) } };
    }
  }
}
